import { AnimatePresence, motion } from "framer-motion";
import { TaskCard } from "@/components/tasks/TaskCard";
import type { ActionItem, ActionState } from "@/hooks/use-action-items";

/**
 * BW19 PR-E + BW20.1 PR-C — dense list view, sorted by due_at ascending
 * (overdue first). Rows fade out (200ms) when state changes to done /
 * cancelled, via framer-motion AnimatePresence.
 */

export function TaskListView({
  items,
  onCycleState,
  onCancel,
  onOpen,
}: {
  items: ActionItem[];
  onCycleState: (id: string, next: ActionState) => void;
  onCancel?: (id: string) => void;
  onOpen: (id: string) => void;
}) {
  if (items.length === 0) {
    return (
      <p
        style={{
          color: "var(--fg-2)",
          padding: "var(--space-6)",
          textAlign: "center",
          background: "var(--bg-2)",
          border: "1px solid var(--hair)",
          borderRadius: "var(--radius-card)",
        }}
      >
        State: no open tasks. Meaning: triage current. Next move: press n to
        capture anything on your mind.
      </p>
    );
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-2)" }}>
      <AnimatePresence initial={false}>
        {items.map((item) => (
          <motion.div
            key={item.id}
            layout
            initial={{ opacity: 1 }}
            exit={{ opacity: 0, height: 0, marginTop: 0 }}
            transition={{ duration: 0.2 }}
            style={{ overflow: "hidden" }}
          >
            <TaskCard
              item={item}
              onCycleState={(next) => onCycleState(item.id, next)}
              onCancel={onCancel ? () => onCancel(item.id) : undefined}
              onOpen={() => onOpen(item.id)}
            />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
